import { ActionTree } from 'vuex'

import { FeatureFlagModuleState } from './feature-flags.model'
import { MutationTypes } from './feature-flags.mutations'
import { LaunchDarklyService } from '@/services/ld.service'

export enum ActionTypes {
  GET_FEATURE_FLAGS = 'GET_FEATURE_FLAGS'
}

export const actions: ActionTree<FeatureFlagModuleState, unknown> = {
  async GET_FEATURE_FLAGS({ commit }) {
    const reducedFlags = await LaunchDarklyService.instance.applicationFlags()
    commit(MutationTypes.SET_FEATURE_FLAGS, reducedFlags)
  }
}
